import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PracticePlaceService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getPracticePlaceByClub(clubCode: string): Observable<PracticePlace[]> {
    return this.http.get<PracticePlace[]>(`${environment.apiUrl}/PracticePlace/${clubCode}`);
  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */

  addPracticePlace(newPracticePlace: PracticePlace) {
    return this.http.post(`${environment.apiUrl}/PracticePlace`, newPracticePlace);
  }

  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */

  updatePracticePlace(practicePlace: PracticePlace) {
    return this.http.post(`${environment.apiUrl}/PracticePlace`, practicePlace);
  }

  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

  deletePracticePlaceByClub(practicePlaceKey: number) {
    return this.http.delete(`${environment.apiUrl}/PracticePlace/${practicePlaceKey}`);
  }

}
